/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dnamw_result_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molecular weight`)
};

const es_dnamw_result_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso molecular`)
};

const de_dnamw_result_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molekulargewicht`)
};

const nl_dnamw_result_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molecuulgewicht`)
};

const fr_dnamw_result_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masse moléculaire`)
};

const it_dnamw_result_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso molecolare`)
};

const pt_br2_dnamw_result_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso molecular`)
};

const pt_dnamw_result_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Massa molecular`)
};

const ja_dnamw_result_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分子量`)
};

const zh_dnamw_result_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分子量`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dnamw_result_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dnamw_result_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dnamw_result_label", locale)
	if (locale === "en") return en_dnamw_result_label(inputs)
	if (locale === "es") return es_dnamw_result_label(inputs)
	if (locale === "de") return de_dnamw_result_label(inputs)
	if (locale === "nl") return nl_dnamw_result_label(inputs)
	if (locale === "fr") return fr_dnamw_result_label(inputs)
	if (locale === "it") return it_dnamw_result_label(inputs)
	if (locale === "pt-BR") return pt_br2_dnamw_result_label(inputs)
	if (locale === "pt") return pt_dnamw_result_label(inputs)
	if (locale === "ja") return ja_dnamw_result_label(inputs)
	return zh_dnamw_result_label(inputs)
};